import { useState } from 'react';
import type { AppRole } from '@casetrace/shared';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useAdminActions } from '../../hooks/use-admin-actions';

const SELECT_CLASS =
  'rounded-md border border-white/[0.1] bg-[#1a1b23] px-3 py-2 text-sm text-[#ededf0]';

export function AdminCreateUserForm() {
  const { createUser } = useAdminActions();
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [appRole, setAppRole] = useState<AppRole>('user');

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    await createUser.mutateAsync({ email, displayName, appRole });
    setEmail('');
    setDisplayName('');
    setAppRole('user');
  }

  return (
    <form onSubmit={(event) => void handleSubmit(event)} className="space-y-3">
      <h3 className="text-xs font-semibold text-text-primary">Legg til bruker</h3>
      <Input
        id="admin-new-user-email"
        type="email"
        label="E-post"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
      />
      <Input
        id="admin-new-user-name"
        label="Navn"
        value={displayName}
        onChange={(event) => setDisplayName(event.target.value)}
        required
      />
      <select
        aria-label="App-rolle"
        className={SELECT_CLASS}
        value={appRole}
        onChange={(event) => setAppRole(event.target.value as AppRole)}
      >
        <option value="user">Bruker</option>
        <option value="admin">Admin</option>
      </select>
      {createUser.isError && <p className="text-xs text-danger/80">Kunne ikke opprette bruker.</p>}
      <Button type="submit" className="w-full" disabled={createUser.isPending}>
        {createUser.isPending ? 'Oppretter…' : 'Opprett bruker'}
      </Button>
    </form>
  );
}
